var exports = {
  "kX": "PurchaseHistoryStatus.module__success___NWpsQU",
  "Ub": "PurchaseHistoryStatus.module__pending___NWpsQU",
  "SU": "PurchaseHistoryStatus.module__muted___NWpsQU",
  "SY": "PurchaseHistoryStatus.module__neutral___NWpsQU",
  "OR": "PurchaseHistoryStatus.module__danger___NWpsQU",
};

module.exports = exports;
